export function formatUsageValue(current: number, limit: number): string {
  return `${current.toLocaleString()} / ${limit.toLocaleString()} used`;
}

export function formatLimitValue(limit: number): string {
  return `Up to ${limit.toLocaleString()}`;
}

export function getUsagePercent(current: number, limit: number): number {
  if (limit <= 0) return 0;
  return Math.min((current / limit) * 100, 100);
}

export function getUsageHint({
  current,
  limit,
  isDestructiveUsage,
  isWarningUsage,
}: {
  current: number;
  limit: number;
  isDestructiveUsage: boolean;
  isWarningUsage: boolean;
}): string | null {
  const remaining = Math.max(limit - current, 0);

  if (remaining === 0) {
    return 'You have reached this limit.';
  }

  if (isDestructiveUsage) {
    return `${remaining.toLocaleString()} remaining before you hit this limit.`;
  }

  if (isWarningUsage) {
    return `${remaining.toLocaleString()} remaining in this cycle.`;
  }

  return null;
}
